export default __webpack_public_path__ + "static/media/13.fe9fce05.jpg";